import { RepositoryBuilder }        from 'alto-orm/lib/orm'
import SKRepository, { BillHeader } from 'alto-react-sk/lib/models'

import Client       from './client'
import Transaction  from './transaction'

KreditRepository = new RepositoryBuilder

KreditRepository.registerRelation(Client,      '/kredit/crud/clients')
KreditRepository.registerRelation(Transaction, '/kredit/crud/transactions')

KreditRepository.registerHasMany(Client, Transaction)
KreditRepository.registerBelongsTo(Transaction, Client)

KreditRepository.registerAllFrom(SKRepository)

KreditRepository.registerBelongsTo(Transaction, BillHeader)

export default KreditRepository # takes backendUrl and auth
